import styled, { css } from 'styled-components';
import {
  spacer,
  mediaBreakpointUp,
  multiply,
  lineHeight,
  fontWeight,
  themeColor,
  resetLinkStyle,
  fontStyle,
} from '@whitelabel/helpers/style';

import IconTick from '@whitelabel/media/icons/small/tick-circle.svg';

export const StyledHeading = styled.div`
  width: 50%;
  line-height: ${lineHeight('headings')};

  ${mediaBreakpointUp('sm')`
    width: 100%;
  `}
`;

export const StyledLocaleListItem = styled.li`
  ${fontStyle('contentMenu')}
  margin-bottom: ${spacer};
  padding: 0;
  list-style-type: none;
`;

/* eslint-disable-next-line jsx-a11y/anchor-has-content */
export const StyledLocaleLink = styled.a<{ $active: boolean }>`
  ${resetLinkStyle}
  font-weight: ${fontWeight('normal')};
  text-transform: capitalize;
  background: transparent;
  cursor: pointer;

  ${({ $active }) =>
    $active &&
    css`
      :not([href]):not([tabindex]) {
        color: ${themeColor('success')};
      }

      &::before {
        content: url(${IconTick});
        padding-inline-end: ${multiply(spacer, 0.5)};
        position: relative;
        top: 2px;
      }
    `}
  :not([href]):not([tabindex]):hover {
    color: ${themeColor('success')};
    background: transparent;
  }
`;
